import { Injectable } from "@angular/core";
import { StreamId, StreamSpecs } from "@common/domain";
import {
  Actions,
  createEffect,
  EffectNotification,
  ofType,
  OnRunEffects
} from "@ngrx/effects";
import { LocalConferenceStreamsListService } from "@youm-front/conference-stream/data-access";
import { partition } from "lodash";
import { Observable } from "rxjs";
import { concatMap, exhaustMap, takeUntil } from "rxjs/operators";
import { LocalVideoConferenceStream } from "youm-lib/conference";
import { RoomActions } from "../actions";
import { RoomStageLayoutEvents } from "../events";

@Injectable()
export class RoomLocalVideoStreamEffects implements OnRunEffects {
  constructor(
    private readonly actions$: Actions,
    private readonly localConferenceStreamsListService: LocalConferenceStreamsListService
  ) {}

  localVideoPausePlay$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(RoomStageLayoutEvents.roomStageLayoutStreamsSetEvent),
        concatMap((_) =>
          this.localVideoPausePlay(
            _.roomStageLayoutStreamsSetEventVO.value.videos
          )
        )
      ),
    { dispatch: false }
  );

  ngrxOnRunEffects(resolvedEffects$: Observable<EffectNotification>) {
    return this.actions$.pipe(
      ofType(RoomActions.init),
      exhaustMap(() =>
        resolvedEffects$.pipe(
          takeUntil(this.actions$.pipe(ofType(RoomActions.destroy)))
        )
      )
    );
  }

  private async localVideoPausePlay(streamIds: StreamId[]) {
    const localVideoFile = "localVideoFile";

    const localVideoStreams =
      this.localConferenceStreamsListService.streams.filter((_) =>
        StreamSpecs.isOfType(_.streamId, localVideoFile)
      ) as LocalVideoConferenceStream[];
    const localVideoStreamIds = streamIds.filter((_) =>
      StreamSpecs.isOfType(_, localVideoFile)
    );

    const [localVideoStreamsToStart, localVideoStreamsToPause] = partition(
      localVideoStreams,
      (_) => localVideoStreamIds.includes(_.streamId as StreamId)
    );

    localVideoStreamsToPause.forEach((_) => _.pause());

    for (const stream of localVideoStreamsToStart) {
      await stream.play();
    }
  }
}
